export default __webpack_public_path__ + "static/media/import-outline-16px.39e49e0b.svg";